import React, { memo, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";

const MessageDisplay = ({ value, width = 280 }) => {
  const overlayRef = useRef(null);

  const estimatedCharsPerWidth = Math.floor((width - 50) / 7); 

  const isTruncated = value?.length > estimatedCharsPerWidth;
  const displayText = isTruncated ? value.substring(0, estimatedCharsPerWidth) + "..." : value;

  if (value?.length > 0) {
    return (
      <>
        <div className="message-display-container" style={{ maxWidth: `${width}px` }}>
          <span className="message-display-text">{displayText}</span>
          {isTruncated && (
            <button
              className="message-display-more-btn"
              onClick={(e) => overlayRef.current?.toggle(e)}
            >
              More
            </button>
          )}
        </div>

        <OverlayPanel ref={overlayRef} className="message-display-overlay" style={{ width: "400px" }}>
          <div className="message-display-overlay-content">
            {value}
          </div>
        </OverlayPanel>
      </>
    );
  }
  return <></>;
};

export default memo(MessageDisplay);
